import { createTheme } from "@mui/material/styles";

const darkTheme = createTheme({
  palette: {
    mode: "dark", // Aktiviert den Dark Mode
    primary: {
      main: "#FF4500",           // Orange
      contrastText: "#000000"    // Bessere Lesbarkeit
    },// Orange (passt gut für Gaming-Seiten)
    secondary: { main: "#00BFFF" }, // Neon-Blau für Akzente
    background: { default: "#121212", paper: "#1e1e1e" }, // Tiefdunkles Hintergrunddesign
    text: { primary: "#ffffff", secondary: "#aaaaaa" } // Helle Schrift für Lesbarkeit
  },
  typography: {
    fontFamily: `"Poppins", sans-serif`,
    h1: { fontFamily: `"Rajdhani", sans-serif`, fontWeight: 700 },
    h2: { fontFamily: `"Rajdhani", sans-serif`, fontWeight: 600 },
    h3: { fontFamily: `"Rajdhani", sans-serif`, fontWeight: 500 },
    h4: { fontFamily: `"Rajdhani", sans-serif`, fontWeight: 400 },
    body1: {
        fontFamily: `"Poppins", sans-serif`
      },
    button: { textTransform: "none", fontWeight: 600 } // Buttons ohne Capslock
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8, // Weiche Kanten für modernen Look
          padding: "12px 24px",
          fontSize: "1rem",
          transition: "0.3s",
          "&:hover": {
            backgroundColor: "#ff632b" // Leuchtender Effekt beim Hover
          }
        }
      }
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          background: "#1e1e1e",
          borderRadius: 12,
          padding: "20px",
          boxShadow: "0px 4px 10px rgba(255, 69, 0, 0.3)" // Sanfter Neon-Effekt
        }
      }
    }
  }
});

export default darkTheme;
